<template>
  <div class="Sidebar--Discount Discount">
    <form class="Discount--Form" v-if="show_custom_code_form">
      <el-form ref="form"
        @submit.prevent="ApplyCustomCode(customCode)"
      >
        <el-form-item
          :label="AppConfig.translations.custom_code_form.type_code"
          class="Discount--Input"
        >
          <el-input placeholder v-model="customCode" class="input-with-select"
            v-on:keyup.enter="ApplyCustomCode(customCode)"
          >
            <el-button
              slot="append"
              type="info"
              @click="ApplyCustomCode(customCode)"
              :loading="CheckoutStatus.CustomCode.add === 'LOADING'"
            >Aplicar</el-button>
          </el-input>
        </el-form-item>
      </el-form>
    </form>
    <div
      class="Discount__Content"
      v-if="customCodeApplied"
    >
      <h6>
        <b>Código aplicado:</b>
      </h6>
      <div v-loading="CheckoutStatus.CustomCode.delete === 'LOADING'" class="Discount__List">
        <el-tag
          closable
          size="small"
          :disable-transitions="false"
          @close="removeCustomCode(customCodeApplied)"
        >{{customCodeApplied}}</el-tag>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions } from 'vuex'
import { mapFilters } from '@/helpers/filters'

export default {
  name: 'CustomCodeForm',
  components: {},
  data () {
    return {
      customCode: '',
      customCodeApplied: '',
      loading: false
    }
  },
  props: ['products'],
  created: function () {
    this.GetCustomCodeApplied()
  },
  computed: {
    ...mapGetters(['AppConfig', 'Checkout', 'CheckoutStatus', 'CustomAttributes']),
    show_custom_code_form () {
      if (
        sessionStorage.getItem('show_custom_code_form')
      ) {
        // sessionStorage.removeItem('show_custom_code_form')
        return true
      }
      if (
        this.AppConfig.components.general &&
        this.AppConfig.components.general.custom_code_form
      ) {
        return !!this.AppConfig.components.general.custom_code_form.show_custom_code_form
      }
      return true
    }

  },
  methods: {
    ...mapActions([
      'UpdateCheckoutState'
    ]),
    ...mapFilters(['formatMoney']),
    async ApplyCustomCode (customCode) {
      if (this.hasCode(customCode)) {
        localStorage.setItem('custom_code', customCode)
        this.customCodeApplied = customCode
      }
    },
    async removeCustomCode (customCode) {
      if (this.hasCode(customCode)) {
        localStorage.removeItem('custom_code')
        this.customCodeApplied = ''
      }
    },
    hasCode (code) {
      if (!code) return false
      return code.length > 1
    },
    GetCustomCodeApplied () {
      var storagedCustomCode = localStorage.getItem('custom_code')
      if (storagedCustomCode) {
        this.customCodeApplied = storagedCustomCode
        return storagedCustomCode
      }
      return null
    }
  }
}
</script>
